import {
  breadcrumb,
  pagination,
  hierarchicalMenu,
  refinementList,
  currentRefinements,
  panel,
  hits,
  stats,
  clearRefinements,
  dynamicWidgets,
  numericMenu,
} from 'instantsearch.js/es/widgets';
import {card} from './shop/card';
import slug from './slug';

( function( app ) {
  const COMPONENT = {
    init: function() {
      const productComparisonButton = document.querySelector( '#js-product-compare' );
      let compareProducts = JSON.parse( sessionStorage.getItem( 'compareProducts' ) || '[]' );
      if ( compareProducts.length > 0 ) {
        productComparisonButton?.classList.remove( 'hidden' );
      } else {
        productComparisonButton?.classList.add( 'hidden' );
      }

      document.addEventListener( 'change', ( e ) => {
        if ( !e.target.matches( '[name="product_comparison' ) ) return;

        const productId = e.target.value;
        compareProducts = JSON.parse( sessionStorage.getItem( 'compareProducts' ) || '[]' );

        if ( e.target.checked ) {
          if ( !compareProducts.includes( productId ) ) {
            compareProducts.push( productId );
          }
        } else {
          compareProducts = compareProducts.filter( ( id ) => id !== productId );
        }

        sessionStorage.setItem( 'compareProducts', JSON.stringify( compareProducts ) );

        if ( compareProducts.length > 0 ) {
          productComparisonButton?.classList.remove( 'hidden' );
        } else {
          productComparisonButton?.classList.add( 'hidden' );
        }
      } );
    },
    getFacetFields: async function( typesenseAdapter ) {
      const response = await typesenseAdapter.searchClient.search( [
        {
          indexName: siteInfo?.search?.collection,
          params: {
            query: '',
            facets: '*',
            hitsPerPage: 0,
          },
        },
      ] );

      return Object.keys( response.results[0].facets || {} ).filter( ( field ) =>
        field.endsWith( '_facet' ),
      );
    },
    getWidgets: async function( typesenseAdapter ) {
      const facetFields = await this.getFacetFields( typesenseAdapter );
      const breadcrumbWidget = breadcrumb( {
        container: '#shop-breadcrumb',
        attributes: ['categories.lvl0', 'categories.lvl1', 'categories.lvl2'],
        cssClasses: {
          root: 'mb-5 [&:has(li:nth-child(1):last-child)]:hidden',
          list: 'flex list-none items-center',
          separator: 'mx-2 text-brand-gray',
          item: 'inline-flex items-center',
        },
        templates: {
          home( data, {html} ) {
            return html`<span>Shop All</span>`;
          },
          separator( data, {html} ) {
            return html`
                <svg class="fill-current w-3 h-3" viewBox="0 0 12 12" fill="none">
                  <path d="M8.51998 5.82006L4.43998 1.74006C4.19998 1.50006 3.83998 1.50006 3.65998 1.74006C3.41998 1.98006 3.41998 2.34006 3.65998 2.52006L7.37998 6.24006L3.65998 9.96006C3.41998 10.2001 3.41998 10.5601 3.65998 10.7401C3.77998 10.8601 3.89998 10.9201 4.07998 10.9201C4.25998 10.9201 4.37998 10.8601 4.49998 10.7401L8.57998 6.66006C8.69998 6.54006 8.75998 6.42006 8.75998 6.24006C8.69998 6.12006 8.63998 5.94006 8.51998 5.82006Z" />
                </svg>
            `;
          },
        },
      } );
      const categoryPanel = panel( {
        templates: {
          header: `<span class="block mb-3 font-bold paragraph-default text-brand-dark-charcoal">Category</span>`,
        },
      } )( hierarchicalMenu );
      const brandPanel = panel( {
        templates: {
          header: `<span class="block mb-3 font-bold paragraph-default text-brand-dark-charcoal">Brand</span>`,
        },
        hidden( options ) {
          return options.items.length === 0;
        },
        cssClasses: {
          root: 'border-t border-brand-light-gray pt-5',
          noRefinementRoot: 'hidden',
        },
      } )( refinementList );

      const makePanel = panel( {
        templates: {
          header: `<span class="block mb-3 font-bold paragraph-default text-brand-dark-charcoal">Make</span>`,
        },
        hidden( options ) {
          return options.items.length === 0;
        },
        cssClasses: {
          root: 'border-t border-brand-light-gray pt-5',
          noRefinementRoot: 'hidden',
        },
      } )( refinementList );

      const enginePanel = panel( {
        templates: {
          header: `<span class="block mb-3 font-bold paragraph-default text-brand-dark-charcoal">Engine</span>`,
        },
        hidden( options ) {
          return options.items.length === 0;
        },
        cssClasses: {
          root: 'border-t border-brand-light-gray pt-5',
          noRefinementRoot: 'hidden',
        },
      } )( refinementList );

      const transmissionPanel = panel( {
        templates: {
          header: `<span class="block mb-3 font-bold paragraph-default text-brand-dark-charcoal">Transmission</span>`,
        },
        hidden( options ) {
          return options.items.length === 0;
        },
        cssClasses: {
          root: 'border-t border-brand-light-gray pt-5',
          noRefinementRoot: 'hidden',
        },
      } )( refinementList );

      const modelPanel = panel( {
        templates: {
          header: `<span class="block mb-3 font-bold paragraph-default text-brand-dark-charcoal">Model</span>`,
        },
        hidden( options ) {
          return options.items.length === 0;
        },
        cssClasses: {
          root: 'border-t border-brand-light-gray pt-5',
          noRefinementRoot: 'hidden',
        },
      } )( refinementList );

      const statsWidget = stats( {
        container: '#totals',
        cssClasses: {
          root: '',
        },
        templates: {
          text( data, {html} ) {
            let queryText = '';
            let wrapperClass = 'flex items-center justify-end w-full';
            if ( data.query?.length > 0 && data.query !== '*' ) {
              wrapperClass = 'grid gap-y-4';
              queryText = html`
                <span class="block hdg-4 flex-grow">Search results for "${data.query}"</span>
              `;
            }

            let offsetText = '';
            if ( data.nbPages > 1 ) {
              const startingNumber = data.page * data.hitsPerPage + 1;
              const endNumber = Math.min( startingNumber + data.hitsPerPage - 1, data.nbHits );
              offsetText = html`<span class="font-medium">Showing ${startingNumber.toLocaleString()} to ${endNumber.toLocaleString()} of ${data.nbHits.toLocaleString()} results</span>`;
            } else {
              if ( !data.hasOneResult ) {
                offsetText = html`<span class="font-medium">Showing ${data.nbHits.toLocaleString()} results</span>`;
              }
            }

            return html`
              <span class="${wrapperClass}">
                ${queryText}
                ${offsetText}
              </span>
            `;
          },
        },
      } );

      const pricePanel = panel( {
        templates: {
          header: `<span class="block mb-3 font-bold paragraph-default text-brand-dark-charcoal">Price</span>`,
        },
        hidden( options ) {
          return options.items.length === 0;
        },
        cssClasses: {
          root: 'border-t border-brand-light-gray pt-5',
          noRefinementRoot: 'hidden',
        },
      } )( numericMenu );

      const statusPanel = panel( {
        templates: {
          header: `<span class="block mb-3 font-bold paragraph-default text-brand-dark-charcoal">Status</span>`,
        },
        hidden( options ) {
          return options.items.length === 0;
        },
        cssClasses: {
          root: 'border-t border-brand-light-gray pt-5',
          noRefinementRoot: 'hidden',
        },
      } )( refinementList );

      const dynamicFilters = dynamicWidgets( {
        container: '#filter-widgets',
        facets: facetFields,
        widgets: facetFields.map( ( fieldName ) => {
          return ( container ) => {
            const displayName = fieldName.replace(
                /_xxcol_|_xxsc_|_xxsp_|_xxapos_|_xxsq_|_xxsl_|_xxop_|_xxcp_|_xxamp_|_xxob_|_xxcb_|_xxcom_|_facet|[:; '"'/()&[\],]/g,
                ( match ) => {
                  const replacements = {
                    '_xxcol_': ':',
                    '_xxsc_': ';',
                    '_xxsp_': ' ',
                    '_xxapos_': '\'',
                    '_xxsq_': '\'',
                    '_xxsl_': '/',
                    '_xxop_': '(',
                    '_xxcp_': ')',
                    '_xxamp_': '&',
                    '_xxob_': '[',
                    '_xxcb_': ']',
                    '_xxcom_': ',',
                    '_facet': ' ',
                  };
                  return replacements[match] || match;
                },
            ).trim().replace( /:$/, '' );

            return panel( {
              templates: {
                header: `<span class="block mb-3 font-bold paragraph-default text-brand-dark-charcoal">${displayName}</span>`,
              },
              hidden( options ) {
                return options.items.length === 0;
              },
              cssClasses: {
                root: 'border-t border-brand-light-gray pt-5',
                noRefinementRoot: 'hidden',
              },
            } )( refinementList )( {
              container,
              sortBy: ['isRefined', 'name:asc'],
              limit: 5,
              showMoreLimit: 300,
              showMore: true,
              attribute: fieldName,
              cssClasses: {
                showMore: 'mt-2 underline text-brand-charcoal hover:text-brand-dark-charcoal text-sm',
                disabledShowMore: 'hidden',
                list: 'grid gap-1.5 list-none text-sm font-medium',
              },
              templates: {
                item( item, {html} ) {
                  const {value, label, count, isRefined} = item;
                  return html`
                    <label class="flex ${item.cssClasses.label}">
                      <input type="checkbox" class="${item.cssClasses.checkbox}" value="${value}" checked="${isRefined}" />
                      <span>
                        <span class="ml-2 ${item.cssClasses.labelText}">${label}</span>
                        <span class="text-sm ml-1 ${item.cssClasses.count}">(${count.toLocaleString()})</span>
                      </span>
                    </label>
                  `;
                },
              },
            } );
          };
        } ),
        transformItems( items, {results} ) {
          if ( !items.includes( 'categories.lvl1' ) && !items.includes( 'categories.lvl2' ) ) {
            return [];
          }

          const facetsWithCounts = items.map( ( attribute ) => {
            const facetValues = results.getFacetValues( attribute, {sortBy: ['count:desc']} );
            const totalCount = Array.isArray( facetValues ) ?
              facetValues.reduce( ( acc, facet ) => acc + facet.count, 0 ) :
              0;

            return {name: attribute, count: totalCount};
          } );

          const topFacets = facetsWithCounts
              .filter( ( facet ) => facet.name.includes( '_facet' ) && facet.count > 0 )
              .sort( ( a, b ) => b.count - a.count )
              .slice( 0, 12 );

          return topFacets.map( ( facet ) => facet.name );
        },
      } );

      return [
        clearRefinements( {
          container: '#clear-filters',
          cssClasses: {
            root: '[&:has(.ais-ClearRefinements-button--disabled)]:hidden border-b border-brand-light-gray py-5',
          },
          excludedAttributes: ['categories.lvl0', 'categories.lvl1', 'categories.lvl2'],
          templates: {
            resetLabel( {hasRefinements}, {html} ) {
              return html`<span class="text-sm font-semibold uppercase underline text-brand-dark-charcoal font-heading hover:text-brand-primary transition-colors">${hasRefinements ? 'Reset Filters' : ''}</span>`;
            },
          },
        } ),
        hits( {
          container: '#shop-products',
          cssClasses: {
            list: 'is-active grid sm:grid-cols-2 md:[&.is-active]:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 products lg:[&.is-active]:grid-cols-3 overflow-hidden [--gap:2em] [--line-offset:calc(var(--gap)_/_2)] [--line-thickness:1px] gap-[--gap]',
            item: 'flex flex-col relative before:bg-brand-light-gray before:absolute before:w-[--line-thickness] before:h-screen before:top-0 before:left-[calc(var(--line-offset)_*_-1)] after:bg-brand-light-gray after:absolute after:h-[--line-thickness] after:top-[calc(var(--line-offset)_*_-1)] after:w-screen',
          },
          transformItems( items, {results} ) {
            return items;
          },
          templates: {
            empty( results, response ) {
              const searchedTerm = results.query !== '*' ? `No products were found matching the search term, <q>${results.query}</q>` : 'No products were found matching the selected options.';
              return `<div class="bg-white shadow-[0_0_0_1px_rgba(35,38,59,.05),0_1px_3px_0_rgba(35,38,59,.15)] rounded-b-[3px] py-8 px-5">${searchedTerm}</div>`;
            },
            item( item ) {
              return card( item, item.__position );
            },
          },
        } ),
        breadcrumbWidget,
        pagination( {
          container: '#shop-pagination',
          padding: 2,
          templates: {
            first: ( data, {html} ) => {
              return html`
                <svg class="fill-current w-5 h-5" viewBox="0 0 20 20" fill="none">
                  <path d="M10.0179 10.0177L16.8361 3.1997C17.1023 2.93343 17.5341 2.93343 17.8003 3.19974C18.0666 3.46602 18.0666 3.8977 17.8003 4.16397L11.4643 10.4999L17.8003 16.8361C18.0666 17.1024 18.0666 17.534 17.8003 17.8003C17.6672 17.9335 17.4927 18 17.3182 18C17.1437 18 16.9692 17.9335 16.8361 17.8003L10.0179 10.9819C9.89003 10.8541 9.81821 10.6806 9.81821 10.4998C9.81821 10.319 9.89003 10.1456 10.0179 10.0177Z" />
                  <path d="M2.01794 10.0177L8.83611 3.1997C9.10234 2.93343 9.53406 2.93343 9.80034 3.19974C10.0666 3.46602 10.0666 3.8977 9.80029 4.16397L3.46426 10.4999L9.80034 16.8361C10.0666 17.1024 10.0666 17.534 9.80029 17.8003C9.6672 17.9335 9.4927 18 9.3182 18C9.1437 18 8.9692 17.9335 8.83606 17.8003L2.01794 10.9819C1.89003 10.8541 1.81821 10.6806 1.81821 10.4998C1.81821 10.319 1.89003 10.1456 2.01794 10.0177Z" />
                </svg>
              `;
            },
            previous: ( data, {html} ) => {
              return html`
                <svg class="fill-current w-5 h-5" viewBox="0 0 20 20" fill="none">
                  <path d="M6.39294 9.51769L13.2111 2.6997C13.4773 2.43343 13.9091 2.43343 14.1753 2.69974C14.4416 2.96602 14.4416 3.3977 14.1753 3.66397L7.83926 9.99987L14.1753 16.3361C14.4416 16.6024 14.4416 17.034 14.1753 17.3003C14.0422 17.4335 13.8677 17.5 13.6932 17.5C13.5187 17.5 13.3442 17.4335 13.2111 17.3003L6.39294 10.4819C6.26503 10.3541 6.19321 10.1806 6.19321 9.99983C6.19321 9.81901 6.26503 9.64556 6.39294 9.51769Z" />
                </svg>
              `;
            },
            next: ( data, {html} ) => {
              return html`
                <svg class="fill-current w-5 h-5" viewBox="0 0 20 20" fill="none">
                  <path d="M13.6071 9.51769L6.78889 2.6997C6.52266 2.43343 6.09094 2.43343 5.82466 2.69974C5.55844 2.96602 5.55844 3.3977 5.82471 3.66397L12.1607 9.99987L5.82466 16.3361C5.55844 16.6024 5.55844 17.034 5.82471 17.3003C5.9578 17.4335 6.1323 17.5 6.3068 17.5C6.4813 17.5 6.6558 17.4335 6.78894 17.3003L13.6071 10.4819C13.735 10.3541 13.8068 10.1806 13.8068 9.99983C13.8068 9.81901 13.735 9.64556 13.6071 9.51769Z" />
                </svg>
              `;
            },
            last: ( data, {html} ) => {
              return html`
                <svg class="fill-current w-5 h-5" viewBox="0 0 20 20" fill="none">
                  <path d="M9.98206 10.0177L3.16389 3.1997C2.89766 2.93343 2.46594 2.93343 2.19966 3.19974C1.93344 3.46602 1.93344 3.8977 2.19971 4.16397L8.53574 10.4999L2.19966 16.8361C1.93344 17.1024 1.93344 17.534 2.19971 17.8003C2.3328 17.9335 2.5073 18 2.6818 18C2.8563 18 3.0308 17.9335 3.16394 17.8003L9.98206 10.9819C10.11 10.8541 10.1818 10.6806 10.1818 10.4998C10.1818 10.319 10.11 10.1456 9.98206 10.0177Z" />
                  <path d="M17.9821 10.0177L11.1639 3.1997C10.8977 2.93343 10.4659 2.93343 10.1997 3.19974C9.93344 3.46602 9.93344 3.8977 10.1997 4.16397L16.5357 10.4999L10.1997 16.8361C9.93344 17.1024 9.93344 17.534 10.1997 17.8003C10.3328 17.9335 10.5073 18 10.6818 18C10.8563 18 11.0308 17.9335 11.1639 17.8003L17.9821 10.9819C18.11 10.8541 18.1818 10.6806 18.1818 10.4998C18.1818 10.319 18.11 10.1456 17.9821 10.0177Z" />
                </svg>
              `;
            },
          },
          cssClasses: {
            root: 'pt-14',
            list: 'flex justify-center list-none items-center [&:has(li:nth-child(5):last-child)]:hidden',
            item: 'px-2 text-brand-charcoal hover:text-brand-dark-charcoal transition-colors duration-150 ease-in-out',
            selectedItem: 'underline text-brand-dark-charcoal',
            disabledItem: 'text-brand-charcoal',
            previousPageItem: 'mr-8',
            nextPageItem: 'ml-8',
            link: '[&:is(span)]:text-brand-charcoal',
          },
        } ),
        categoryPanel( {
          container: '#category-list',
          attributes: ['categories.lvl0', 'categories.lvl1', 'categories.lvl2'],
          sortBy: ['isRefined', 'name:asc'],
          showMoreLimit: 300,
          showParentLevel: false,
          showMore: true,
          limit: 5,
          separator: ' >> ',
          cssClasses: {
            list: 'grid gap-1.5 text-sm font-medium list-none',
            link: 'hover:underline',
            showMore: 'mt-2 underline text-brand-charcoal hover:text-brand-dark-charcoal text-sm',
          },
          templates: {
            item( data, {html} ) {
              let url = data.value.split( '>>' );
              url = url.map( ( value ) => slug( value ) );
              url = url.join( '/' );
              url = `${window.siteInfo?.productCategoryUrl}/${url}`;
              return html`
                <a class="${data.cssClasses.link}" href="${url}">
                  <span class="${data.cssClasses.label}">${data.label}</span>
                  <span class="text-sm ml-1 ${data.cssClasses.count}">
                    (${data.count.toLocaleString()})
                  </span>
                </a>
              `;
            },
          },
        } ),
        brandPanel( {
          container: '#brand-list',
          sortBy: ['isRefined', 'name:asc'],
          limit: 5,
          showMoreLimit: 300,
          showMore: true,
          attribute: 'brand',
          cssClasses: {
            showMore: 'mt-2 underline text-brand-charcoal hover:text-brand-dark-charcoal text-sm',
            list: 'grid gap-1.5 list-none text-sm font-medium',
          },
          templates: {
            item( item, {html} ) {
              const {value, label, count, isRefined} = item;
              return html`
                <label class="flex ${item.cssClasses.label}">
                  <input type="checkbox" class="${item.cssClasses.checkbox}" value="${value}" checked="${isRefined}" />
                  <span>
                    <span class="ml-2 ${item.cssClasses.labelText}">${label}</span>
                    <span class="text-sm ml-1 ${item.cssClasses.count}">(${count.toLocaleString()})</span>
                  </span>
                </label>
              `;
            },
          },
        } ),
        makePanel( {
          container: '#make-list',
          sortBy: ['isRefined', 'name:asc'],
          limit: 5,
          showMoreLimit: 300,
          showMore: true,
          attribute: 'make',
          cssClasses: {
            showMore: 'mt-2 underline text-brand-charcoal hover:text-brand-dark-charcoal text-sm',
            list: 'grid gap-1.5 list-none text-sm font-medium',
          },
          templates: {
            item( item, {html} ) {
              const {value, label, count, isRefined} = item;
              return html`
                <label class="flex ${item.cssClasses.label}">
                  <input type="checkbox" class="${item.cssClasses.checkbox}" value="${value}" checked="${isRefined}" />
                  <span>
                    <span class="ml-2 ${item.cssClasses.labelText}">${label}</span>
                    <span class="text-sm ml-1 ${item.cssClasses.count}">(${count.toLocaleString()})</span>
                  </span>
                </label>
              `;
            },
          },
        } ),
        enginePanel( {
          container: '#engine-list',
          sortBy: ['isRefined', 'name:asc'],
          limit: 5,
          showMoreLimit: 300,
          showMore: true,
          attribute: 'engine',
          cssClasses: {
            showMore: 'mt-2 underline text-brand-charcoal hover:text-brand-dark-charcoal text-sm',
            list: 'grid gap-1.5 list-none text-sm font-medium',
          },
          templates: {
            item( item, {html} ) {
              const {value, label, count, isRefined} = item;
              return html`
                <label class="flex ${item.cssClasses.label}">
                  <input type="checkbox" class="${item.cssClasses.checkbox}" value="${value}" checked="${isRefined}" />
                  <span>
                    <span class="ml-2 ${item.cssClasses.labelText}">${label}</span>
                    <span class="text-sm ml-1 ${item.cssClasses.count}">(${count.toLocaleString()})</span>
                  </span>
                </label>
              `;
            },
          },
        } ),
        transmissionPanel( {
          container: '#transmission-list',
          sortBy: ['isRefined', 'name:asc'],
          limit: 5,
          showMoreLimit: 300,
          showMore: true,
          attribute: 'transmission',
          cssClasses: {
            showMore: 'mt-2 underline text-brand-charcoal hover:text-brand-dark-charcoal text-sm',
            list: 'grid gap-1.5 list-none text-sm font-medium',
          },
          templates: {
            item( item, {html} ) {
              const {value, label, count, isRefined} = item;
              return html`
                <label class="flex ${item.cssClasses.label}">
                  <input type="checkbox" class="${item.cssClasses.checkbox}" value="${value}" checked="${isRefined}" />
                  <span>
                    <span class="ml-2 ${item.cssClasses.labelText}">${label}</span>
                    <span class="text-sm ml-1 ${item.cssClasses.count}">(${count.toLocaleString()})</span>
                  </span>
                </label>
              `;
            },
          },
        } ),
        modelPanel( {
          container: '#model-list',
          sortBy: ['isRefined', 'name:asc'],
          limit: 5,
          showMoreLimit: 300,
          showMore: true,
          attribute: 'model',
          cssClasses: {
            showMore: 'mt-2 underline text-brand-charcoal hover:text-brand-dark-charcoal text-sm',
            list: 'grid gap-1.5 list-none text-sm font-medium',
          },
          templates: {
            item( item, {html} ) {
              const {value, label, count, isRefined} = item;
              return html`
                <label class="flex ${item.cssClasses.label}">
                  <input type="checkbox" class="${item.cssClasses.checkbox}" value="${value}" checked="${isRefined}" />
                  <span>
                    <span class="ml-2 ${item.cssClasses.labelText}">${label}</span>
                    <span class="text-sm ml-1 ${item.cssClasses.count}">(${count.toLocaleString()})</span>
                  </span>
                </label>
              `;
            },
          },
        } ),
        statusPanel( {
          container: '#status-list',
          attribute: 'status',
          cssClasses: {
            showMore: 'mt-2 underline text-brand-charcoal hover:text-brand-dark-charcoal text-sm',
            list: 'grid gap-1.5 list-none text-sm font-medium',
          },
          templates: {
            item( item, {html} ) {
              const {value, label, count, isRefined} = item;
              return html`
                <label class="flex ${item.cssClasses.label}">
                  <input type="checkbox" class="${item.cssClasses.checkbox}" value="${value}" checked="${isRefined}" />
                  <span>
                    <span class="ml-2 ${item.cssClasses.labelText}">${label}</span>
                    <span class="text-sm ml-1 ${item.cssClasses.count}">(${count.toLocaleString()})</span>
                  </span>
                </label>
              `;
            },
          },
          transformItems( items, {results} ) {
            const wholesaleStatusMap = {
              'On Sale': !siteInfo?.search?.isWholesale,
              'Wholesale On Sale': siteInfo?.search?.isWholesale,
            };

            return items.filter( ( item ) => {
              if ( Object.hasOwn( wholesaleStatusMap, item.value ) ) {
                return wholesaleStatusMap[item.value];
              }

              return true;
            } ).map( ( item ) => {
              item.label = item.label.replace( 'Wholesale', '' );
              return item;
            } );
          },
        } ),
        dynamicFilters,
        pricePanel( {
          container: '#price-list',
          attribute: 'price',
          items: [
            {label: '$0 - $99', start: 0, end: 99},
            {label: '$100 - $199', start: 100, end: 199},
            {label: '$200 - $299', start: 200, end: 299},
            {label: '$300 - $399', start: 300, end: 399},
            {label: '$400 - $499', start: 400, end: 499},
            {label: '$500+', start: 500},
          ],
          cssClasses: {
            showMore: 'mt-2 underline text-brand-charcoal hover:text-brand-dark-charcoal text-sm',
            list: 'grid gap-1.5 list-none text-sm font-medium',
          },
          templates: {
            item( item, {html} ) {
              const {value, label, count, isRefined} = item;
              return html`
                <label class="flex ${item.cssClasses.label}">
                  <input type="radio" class="${item.cssClasses.radio}" name="${item.attribute}" value="${value}" checked="${isRefined}" />
                  <span>
                    <span class="ml-2 ${item.cssClasses.labelText}">${label}</span>
                  </span>
                </label>
              `;
            },
          },
        } ),
        currentRefinements( {
          container: '#selected-filters',
          includedAttributes: ['brand', 'make', 'engine', 'transmission', 'status', 'price', ...facetFields],
          cssClasses: {
            root: '[&:not(.ais-CurrentRefinements--noRefinement)]:mt-5',
            noRefinementRoot: 'hidden',
            list: 'list-none flex flex-wrap gap-2',
            label: 'hidden',
            item: 'contents text-sm',
            categoryLabel: 'order-2',
            category: 'inline-flex items-center py-1 pl-0.5 pr-2 rounded paragraph-small bg-brand-off-white text-brand-dark-charcoal',
            delete: 'order-1 py-1 px-1.5',
          },
        } ),
        statsWidget,
      ];
    },
    finalize: function() {
      $( document.body ).on( 'updated_checkout', function() {
        $( '#place_order' ).html( '<span>Submit Order</span>' );
      } );
    },
  };

  app.registerComponent( 'shop', COMPONENT );
} )( app );
